import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0B0F14', color: '#E6EDF3' }}>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-8"
        >
          <ArrowLeft size={20} />
          Zurück zur Startseite
        </Link>

        <h1 className="text-4xl font-bold mb-8" style={{ color: '#1EA0E6' }}>
          Datenschutzerklärung
        </h1>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              1. Datenschutz auf einen Blick
            </h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">Allgemeine Hinweise</h3>
            <p className="mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten 
              sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Wer ist verantwortlich für die Datenerfassung?</h3>
            <p className="mb-4">
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber:
            </p>
            <div className="ml-4 mb-4">
              <p>Andreas Trenter</p>
              <p>STR-Performance</p>
              <p>Dorfweg 8</p>
              <p>4718 Holderbank, Schweiz</p>
              <p>E-Mail: support@carcortex-ai.com</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              2. Welche Daten erfassen wir und wofür?
            </h2>

            <h3 className="text-xl font-semibold mb-3 mt-6">Registrierung und Account-Daten</h3>
            <p className="mb-4">Bei der Registrierung erfassen wir:</p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>E-Mail-Adresse</strong> (Pflichtfeld) - für Login und Kommunikation</li>
              <li><strong>Passwort</strong> (verschlüsselt gespeichert)</li>
              <li><strong>Name</strong> (optional) - für persönliche Ansprache</li>
              <li><strong>Firma</strong> (optional) - für Werkstätten</li>
              <li><strong>Telefonnummer</strong> (optional) - für Support</li>
            </ul>
            <p className="mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Fahrzeug- und Diagnosedaten</h3>
            <p className="mb-4">Bei der Nutzung der Diagnose-Funktion speichern wir:</p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Fahrzeugdaten:</strong> Marke, Modell, Motor, Baujahr</li>
              <li><strong>Symptombeschreibungen:</strong> Ihre Eingaben zu Fahrzeugproblemen</li>
              <li><strong>Diagnose-Verläufe:</strong> Schritte und Ergebnisse</li>
              <li><strong>Hochgeladene Dateien:</strong> Bilder, Videos (falls vorhanden)</li>
            </ul>
            <p className="mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
            </p>
            <p className="mb-4 font-semibold" style={{ color: '#FFA500' }}>
              Wichtig: Diese Daten werden verwendet, um Ihnen KI-gestützte Diagnosevorschläge zu geben. 
              Die Daten werden NICHT mit Dritten geteilt (außer den unten genannten Auftragsverarbeitern).
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Zahlungsdaten</h3>
            <p className="mb-4">
              Bei der Bezahlung über Stripe werden folgende Daten verarbeitet:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Zahlungsinformationen</strong> (Kreditkarte, etc.) - direkt an Stripe übermittelt</li>
              <li><strong>Rechnungsdaten</strong> - für Ihre Unterlagen</li>
              <li><strong>Transaktions-ID</strong> - für Nachverfolgung</li>
            </ul>
            <p className="mb-4">
              <strong>Wichtig:</strong> Zahlungsdaten (Kartennummer, etc.) werden NICHT auf unseren 
              Servern gespeichert, sondern direkt über Stripe verarbeitet.
            </p>
            <p className="mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">OBD-Daten (Live-Diagnose)</h3>
            <p className="mb-4">
              Bei Verwendung des OBD-Agents werden folgende Daten erfasst:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Live-Fahrzeugdaten:</strong> Motordaten, Sensormesswerte, Fehlercodes</li>
              <li><strong>Geräte-Informationen:</strong> OBD-Dongle-Typ, Software-Version</li>
              <li><strong>Verwendungsstatistiken:</strong> Anzahl und Zeitpunkt der Diagnosen</li>
            </ul>
            <p className="mb-4">
              <strong>Wichtig:</strong> OBD-Daten werden nur während der Diagnose übertragen und zum Zweck der Fehleranalyse verwendet. 
              Standortdaten werden NICHT erfasst.
            </p>
            <p className="mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Empfehlungsprogramm</h3>
            <p className="mb-4">
              Bei Teilnahme am Empfehlungsprogramm speichern wir:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Empfehlungscode:</strong> Ihr eindeutiger Referral-Code</li>
              <li><strong>Statistiken:</strong> Anzahl der Klicks, Registrierungen und erfolgreichen Empfehlungen</li>
              <li><strong>Credit-Historie:</strong> Verdiente und verwendete Credits</li>
              <li><strong>E-Mail-Adresse empfohlener Personen:</strong> Nur zur Zuordnung von Credits</li>
            </ul>
            <p className="mb-4">
              <strong>Wichtig:</strong> Empfohlene Personen werden darüber informiert, wer sie empfohlen hat. 
              Ihre E-Mail-Adresse wird dem Empfehlenden NICHT mitgeteilt.
            </p>
            <p className="mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Flottenmanagement (FMS)</h3>
            <p className="mb-4">
              Bei Nutzung der FMS-Funktionen speichern wir:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Flottendaten:</strong> Fahrzeuginformationen, Kennzeichen, VIN</li>
              <li><strong>Fahrerdaten:</strong> Name, Führerscheinnummer, Kontaktdaten (sofern eingegeben)</li>
              <li><strong>Wartungspläne:</strong> Termine, durchgeführte Wartungen, Kosten</li>
              <li><strong>Team-Mitglieder:</strong> E-Mail-Adressen und Zugriffsrechte eingeladener Personen</li>
            </ul>
            <p className="mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Fahrzeugdaten-Bibliothek</h3>
            <div className="bg-yellow-900 bg-opacity-20 border-2 border-yellow-500 p-4 rounded-lg mb-4">
              <p className="font-bold mb-2" style={{ color: '#F59E0B' }}>
                ⚠️ WICHTIG: Herkunft der technischen Fahrzeugdaten
              </p>
              <p className="mb-2" style={{ color: '#E6EDF3' }}>
                Die technischen Fahrzeugdaten in unserer Bibliothek werden durch automatisierte Web-Recherche 
                und KI-Analyse gesammelt. Diese Daten stammen aus öffentlich zugänglichen Quellen, jedoch 
                <strong> NICHT direkt von Fahrzeugherstellern</strong>.
              </p>
            </div>
            <p className="mb-4">
              Bei Nutzung der Fahrzeugdaten-Bibliothek verarbeiten wir:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Suchverlauf:</strong> Welche Fahrzeuge/Spezifikationen Sie abgerufen haben</li>
              <li><strong>Verwendungsstatistiken:</strong> Häufigkeit und Zeitpunkt der Nutzung</li>
              <li><strong>Keine personenbezogenen Fahrzeugdaten:</strong> Die Datenbank enthält nur allgemeine technische Spezifikationen</li>
            </ul>
            <p className="mb-4 font-semibold" style={{ color: '#FFA500' }}>
              Wichtig: Die gesammelten technischen Daten werden intern gespeichert und NICHT an Dritte weitergegeben. 
              Es besteht keine direkte Verbindung zu Fahrzeugherstellern oder deren Datenbanken.
            </p>
            <p className="mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              3. Cookies und lokale Speicherung
            </h2>
            <p className="mb-4">
              Unsere Website verwendet Cookies und Local Storage, um die Funktionalität zu gewährleisten.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Essenzielle Cookies</h3>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Login-Token:</strong> Speichert Ihre Anmeldeinformationen (lokal im Browser)</li>
              <li><strong>Session-Cookies:</strong> Für die Nutzung der Plattform erforderlich</li>
            </ul>
            <p className="mb-4">
              Diese Cookies sind technisch notwendig und können nicht deaktiviert werden.
            </p>
            <p className="mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Externe Cookies</h3>
            <p className="mb-4">
              Bei der Nutzung von Stripe werden Cookies von Stripe gesetzt. Details finden Sie in der 
              <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline ml-1">
                Datenschutzerklärung von Stripe
              </a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              4. Weitergabe von Daten an Dritte
            </h2>
            <p className="mb-4">
              Wir geben Ihre Daten nur an Dritte weiter, soweit dies für die Vertragserfüllung 
              erforderlich ist:
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Auftragsverarbeiter (Art. 28 DSGVO)</h3>
            
            <div className="mb-6">
              <p className="font-semibold mb-2">Stripe (Zahlungsabwicklung)</p>
              <p className="ml-4 mb-2">Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland</p>
              <p className="ml-4 mb-2">
                <strong>Zweck:</strong> Zahlungsabwicklung und Rechnungsstellung
              </p>
              <p className="ml-4 mb-2">
                <strong>Daten:</strong> Zahlungsinformationen, E-Mail, Name
              </p>
              <p className="ml-4">
                <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">
                  Datenschutzerklärung von Stripe
                </a>
              </p>
            </div>

            <div className="mb-6">
              <p className="font-semibold mb-2">OpenAI (KI-Diagnose)</p>
              <p className="ml-4 mb-2">OpenAI, L.L.C., 3180 18th Street, San Francisco, CA 94110, USA</p>
              <p className="ml-4 mb-2">
                <strong>Zweck:</strong> KI-gestützte Diagnosevorschläge
              </p>
              <p className="ml-4 mb-2">
                <strong>Daten:</strong> Fahrzeugdaten, Symptombeschreibungen (anonymisiert)
              </p>
              <p className="ml-4 mb-2 font-semibold" style={{ color: '#FFA500' }}>
                Wichtig: Es werden KEINE personenbezogenen Daten (Name, E-Mail) an OpenAI übermittelt!
              </p>
              <p className="ml-4">
                <a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">
                  Datenschutzerklärung von OpenAI
                </a>
              </p>
            </div>

            <div className="mb-6">
              <p className="font-semibold mb-2">E-Mail-Versand</p>
              <p className="ml-4 mb-2">
                <strong>Zweck:</strong> Versand von Willkommens-E-Mails, Zahlungsbestätigungen
              </p>
              <p className="ml-4 mb-2">
                <strong>Daten:</strong> E-Mail-Adresse, Name
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              5. Wie lange speichern wir Ihre Daten?
            </h2>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Account-Daten:</strong> Bis zur Löschung Ihres Accounts</li>
              <li><strong>Fahrzeug- und Diagnosedaten:</strong> Bis zur Löschung Ihres Accounts</li>
              <li><strong>Zahlungsdaten:</strong> 10 Jahre (gesetzliche Aufbewahrungspflicht)</li>
              <li><strong>E-Mail-Logs:</strong> 30 Tage</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              6. Ihre Rechte
            </h2>
            <p className="mb-4">Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>

            <div className="space-y-4">
              <div>
                <p className="font-semibold mb-2">Auskunftsrecht (Art. 15 DSGVO)</p>
                <p className="ml-4">Sie können Auskunft über Ihre gespeicherten Daten verlangen.</p>
              </div>

              <div>
                <p className="font-semibold mb-2">Recht auf Berichtigung (Art. 16 DSGVO)</p>
                <p className="ml-4">Sie können die Berichtigung unrichtiger Daten verlangen.</p>
              </div>

              <div>
                <p className="font-semibold mb-2">Recht auf Löschung (Art. 17 DSGVO)</p>
                <p className="ml-4">Sie können die Löschung Ihrer Daten verlangen (Ausnahme: gesetzliche Aufbewahrungspflichten).</p>
              </div>

              <div>
                <p className="font-semibold mb-2">Recht auf Datenportabilität (Art. 20 DSGVO)</p>
                <p className="ml-4">Sie können Ihre Daten in einem strukturierten Format erhalten.</p>
              </div>

              <div>
                <p className="font-semibold mb-2">Widerspruchsrecht (Art. 21 DSGVO)</p>
                <p className="ml-4">Sie können der Verarbeitung Ihrer Daten widersprechen.</p>
              </div>

              <div>
                <p className="font-semibold mb-2">Beschwerderecht (Art. 77 DSGVO)</p>
                <p className="ml-4">
                  Sie haben das Recht, sich bei der zuständigen Datenschutzbehörde zu beschweren:
                </p>
                <p className="ml-4 mt-2">
                  Eidgenössischer Datenschutz- und Öffentlichkeitsbeauftragter (EDÖB)<br />
                  Feldeggweg 1<br />
                  3003 Bern, Schweiz<br />
                  <a href="https://www.edoeb.admin.ch" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">
                    www.edoeb.admin.ch
                  </a>
                </p>
              </div>
            </div>

            <p className="mt-6 mb-4">
              <strong>Kontakt für Datenschutzanfragen:</strong><br />
              E-Mail: support@carcortex-ai.com
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              7. Datensicherheit
            </h2>
            <p className="mb-4">
              Wir verwenden geeignete technische und organisatorische Sicherheitsmaßnahmen, um Ihre 
              Daten gegen Manipulation, Verlust, Zerstörung oder unbefugten Zugriff zu schützen:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>HTTPS-Verschlüsselung für alle Datenübertragungen</li>
              <li>Verschlüsselte Speicherung von Passwörtern (bcrypt)</li>
              <li>Regelmäßige Sicherheitsupdates</li>
              <li>Zugriffsbeschränkungen auf Datenbankebene</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              8. Änderungen dieser Datenschutzerklärung
            </h2>
            <p className="mb-4">
              Wir behalten uns vor, diese Datenschutzerklärung zu aktualisieren, um sie an geänderte 
              Rechtslagen oder Änderungen unserer Dienstleistungen anzupassen. Die aktuelle Version 
              finden Sie stets auf dieser Seite.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t" style={{ borderColor: '#1F2937' }}>
            <p className="text-sm text-gray-400">
              Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
